<template>
  <div v-if="vacancyProjectPage" class="vx-card">
    <div class="vx-card__header">
      <div class="vx-card__title">
        <h4 class>Neueste Stellenangebote</h4>
      </div>
    </div>
    <div class="vx-card__collapsible-content vs-con-loading__container z-0">
      <div class="vx-card__body">
        <vs-table class="table-fixed w-full" :data="vacancyProjectPage.results">
          <template slot="thead">
            <vs-th>ID</vs-th>
            <vs-th>Stelle</vs-th>
            <vs-th>Unternehmen</vs-th>
            <vs-th>Datum</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr v-for="vacancy of data" :key="vacancy.id">
              <vs-td>
                {{ vacancy.number }}
              </vs-td>
              <vs-td>
                <router-link
                  :to="{ name: 'project.edit', params: { id: vacancy.id } }"
                  >{{ vacancy.title }}</router-link
                >
              </vs-td>
              <vs-td>
                <template v-if="vacancy.company">
                  {{ vacancy.company.name }}
                </template>
              </vs-td>
              <vs-td>
                {{ $d(new Date(vacancy.updatedAt), "short") }} Uhr
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="text-right mx-3 mt-3">
          <router-link :to="{ name: 'job.overview' }" class="overview-link">
            Alle Stellen <i class="fal fa-arrow-right"></i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  apollo: {
    vacancyProjectPage: {
      query: gql`
        query Jobs($page: Int, $size: Int) {
          vacancyProjectPage(page: $page, size: $size, filter: {}) {
            total
            results {
              id
              number
              title
              company {
                id
                name
              }
              updatedAt
            }
          }
        }
      `,
      variables() {
        return {
          page: 1,
          size: 16
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
table {
  tr {
    td {
      padding: 10px;
    }
  }
}
</style>
